export default {"src":"/_next/static/image/public/images/ic_btn_homecare.41bfc3618507701d2dfba601e56a7a28.svg","height":48,"width":48};